import { inject, Injectable } from '@angular/core';
import { AbstractTrackingSettingsProviderService, CURRENT_URL, PREVIOUS_URL, TrackingData } from '@iot-platform/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class TrackingSettingsProviderService extends AbstractTrackingSettingsProviderService {
  private readonly currentUrl$: Observable<string> = inject(CURRENT_URL);
  private readonly previousUrl$: Observable<string> = inject(PREVIOUS_URL);

  getTrackingData$(): Observable<TrackingData> {
    return of({});
  }

  getCurrentUrl$(): Observable<string> {
    return this.currentUrl$;
  }

  getPreviousUrl$(): Observable<string> {
    return this.previousUrl$;
  }
}
